import { createApiV2 } from "./common";

export const getTimezones = () => createApiV2("GET", "timezones/")();
